<div class="container-fluid mt-3">
  <h3>AI Commands</h3>

  <app-ai-command-list [commands]="commands" (onDeleted)="loadCommands()" (onRetried)="loadCommands()"></app-ai-command-list>
</div>
